export default __webpack_public_path__ + "static/media/logo.85707a33.png";